module.exports = "ul {\n  padding-left: inherit; }\n"